<script>
  // TODO: A11y: Avoid using autofocus
  export let ethereum_request
  export let address

  import Verify from './personal_verify.svelte'

  let value = ''
  let disabled

  let message
  let sign

  async function personal_sign() {
    message    = value
    sign       = ethereum_request('personal_sign', message, address)
    try {
      disabled = true
      await      sign
      value    = '' // empty input after sign successful
    } finally {
      disabled = false
    }
  }
</script>

<form on:submit|preventDefault={personal_sign}>
  <input autofocus bind:value>
  <button {disabled}>personal_sign</button>
</form>

{#if sign}
  {#await sign}
  waiting for sign...

  {:then  signature}
  <Verify {address} {message} {signature} />

  {:catch error}
  error: {error.message}
  {/await}
{/if}
